/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedDetailReference_item = {
    readonly isAvailable: boolean | null;
    readonly isSold: boolean | null;
    readonly isAuctionEnabled: boolean | null;
    readonly hasPrivateListing: boolean | null;
    readonly isListingUnlisted: boolean | null;
    readonly hasActiveHoldForBuyer?: boolean | null | undefined;
    readonly seller: {
        readonly isAccessible: boolean | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailItemInvoice_item">;
    readonly " $refType": "PdpSharedDetailReference_item";
};
export type PdpSharedDetailReference_item$data = PdpSharedDetailReference_item;
export type PdpSharedDetailReference_item$key = {
    readonly " $data"?: PdpSharedDetailReference_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailReference_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailReference_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAvailable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPrivateListing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isListingUnlisted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccessible",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userId"
            }
          ],
          "kind": "ScalarField",
          "name": "hasActiveHoldForBuyer",
          "storageKey": null
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailItemInvoice_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '262ba55082da350dc024cdfb5cfb9e74';
export default node;
